<template>
  <div>
    <Breadcrumbs main="Розыгрыши" title="Редактирование розыгрыша"></Breadcrumbs>
    <div class="container-fluid">
      <div class="row">
        <div class="col-md-12">
          <div class="card">
            <div class="card-header">
              <h5>Редактирование розыгрыша</h5>
            </div>
            <div class="card-body">
              <b-card>
                <div v-if="isLoading" class="loading-wrapper">
                  <b-spinner class="spinner"></b-spinner>
                </div>
                <GiveawayForm
                    v-else
                    ref="giveawayForm"
                    v-model="giveawayData"
                    :game-locked="gameLocked"
                    :is-saving="isSaving"
                    submit-text="Сохранить изменения"
                    @submit="submitGiveaway"
                />
              </b-card>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {mapActions} from 'vuex';
import GiveawayForm from "@/pages/Giveaways/GiveawayForm.vue";
import {GiveawayAdapterMixin, getGiveawayGameId} from "@/mixins/Giveaways/GiveawayAdapterMixin";

export default {
  name: 'EditGiveaway',
  mixins: [GiveawayAdapterMixin],
  components: {GiveawayForm},
  data() {
    return {
      isLoading: false,
      isSaving: false,
      giveawayData: {
        name: '',
        game_id: null,
        starts_at: null,
        ends_at: null,
        coupons_count: null,
      },
      // Игра уже выбрана и промокоды начали активировать — бэк сменить её
      // не даст (validation.giveaway_game_locked), поле сразу закрыто.
      // Старый розыгрыш без игры не закрываем: игру ему нужно проставить.
      gameLocked: false,
    };
  },
  computed: {
    giveawayId() {
      return this.$route.params.id;
    }
  },
  mounted() {
    this.loadGiveaway();
  },
  methods: {
    ...mapActions('moduleGiveaways', ['fetchGiveaway', 'updateGiveaway']),
    async loadGiveaway() {
      this.isLoading = true;
      try {
        const response = await this.fetchGiveaway(this.giveawayId);
        const giveaway = response.data.data;

        this.giveawayData = {
          name: giveaway.name,
          game_id: getGiveawayGameId(giveaway),
          starts_at: giveaway.starts_at ? new Date(giveaway.starts_at) : null,
          ends_at: giveaway.ends_at ? new Date(giveaway.ends_at) : null,
          coupons_count: giveaway.coupons_count ?? null,
        };
        this.gameLocked = this.giveawayData.game_id != null && this.getCouponsActivated(giveaway) > 0;
      } catch (error) {
        console.error('Error loading giveaway:', error);
      } finally {
        this.isLoading = false;
      }
    },
    async submitGiveaway() {
      this.isSaving = true;
      try {
        await this.updateGiveaway({
          id: this.giveawayId,
          giveawayData: {
            name: this.giveawayData.name,
            // Закреплённую игру не шлём вовсе: менять её нечего, а лишнее
            // поле — повод для бэка ответить giveaway_game_locked.
            ...(this.gameLocked ? {} : {game_id: this.giveawayData.game_id}),
            starts_at: this.toIsoWithOffset(this.giveawayData.starts_at),
            ends_at: this.toIsoWithOffset(this.giveawayData.ends_at),
            coupons_count: this.giveawayData.coupons_count,
          }
        });
        this.$router.push({name: 'list_giveaways'});
      } catch (error) {
        console.error('Error updating giveaway:', error);
        this.$refs.giveawayForm?.setServerErrors(error?.response?.data?.errors);
      } finally {
        this.isSaving = false;
      }
    },
  },
};
</script>

<style scoped>
.loading-wrapper {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 200px;
}
</style>
